import { notify } from 'utils/reduxUtils';

export const types = {
  ACKNOWLEDGE_CHANNEL_NOTIFICATIONS_REQUEST:
    'chat/ACKNOWLEDGE_CHANNEL_NOTIFICATIONS_REQUEST',
  ACKNOWLEDGE_THREAD_NOTIFICATIONS_REQUEST:
    'chat/ACKNOWLEDGE_THREAD_NOTIFICATIONS_REQUEST',
  ANNOTATION_INPUT_RECORD_EDITOR_STATE:
    'chat/ANNOTATION_INPUT_RECORD_EDITOR_STATE',
  ANNOTATION_TOOL_SET_ACTIVE: 'chat/ANNOTATION_TOOL_SET_ACTIVE',
  ANNOTATION_TOOL_SET_INACTIVE: 'chat/ANNOTATION_TOOL_SET_INACTIVE',
  CHANNELS_LIST_ERROR: 'chat/CHANNELS_LIST_ERROR',
  CHANNELS_LIST_REQUEST: 'chat/ANNOTATIONS_LIST_REQUEST',
  CHANNELS_LIST_SUCCESS: 'chat/ANNOTATIONS_LIST_SUCCESS',
  CHAT_SOCKET_INITIALIZE_REQUEST: 'chat/CHAT_SOCKET_INITIALIZE_REQUEST',
  CHAT_APP_INIT: 'chat/CHAT_APP_INIT',
  CHAT_APP_RESET: 'chat/CHAT_APP_RESET',
  CHAT_DRAWER_CLOSE: 'chat/CHAT_DRAWER_CLOSE',
  CHAT_DRAWER_OPEN: 'chat/CHAT_DRAWER_OPEN',
  CHAT_DRAWER_STATE_SET: 'chat/CHAT_DRAWER_STATE_SET',
  COMMENT_INPUT_RECORD_EDITOR_STATE: 'chat/COMMENT_INPUT_RECORD_EDITOR_STATE',
  COMMENTS_DISPLAY_ALL_COMMENTS: 'chat/COMMENTS_DISPLAY_ALL_COMMENTS',
  COMMENTS_TOGGLE_DISPLAY: 'chat/COMMENTS_TOGGLE_DISPLAY',
  CREATE_ANNOTATION_ERROR: 'chat/CREATE_ANNOTATION_ERROR',
  CREATE_ANNOTATION_INPUT_REINITIALIZED:
    'chat/CREATE_ANNOTATION_INPUT_REINITIALIZED',
  CREATE_ANNOTATION_RECORD_ANNOATION_CREATING:
    'chat/CREATE_ANNOTATION_RECORD_ANNOATION_CREATING',
  CREATE_ANNOTATION_REQUEST: 'chat/CREATE_ANNOTATION_REQUEST',
  CREATE_ANNOTATION_SUCCESS: 'chat/CREATE_ANNOTATION_SUCCESS',
  CREATE_COMMENT_ERROR: 'chat/CREATE_COMMENT_ERROR',
  CREATE_COMMENT_INPUT_REINITIALIZED: 'chat/CREATE_COMMENT_INPUT_REINITIALIZED',
  CREATE_COMMENT_REQUEST: 'chat/CREATE_COMMENT_REQUEST',
  CREATE_COMMENT_SUCCESS: 'chat/CREATE_COMMENT_SUCCESS',
  DELETE_ANNOTATION_ERROR: 'chat/DELETE_ANNOTATION_ERROR',
  DELETE_ANNOTATION_REQUEST: 'chat/DELETE_ANNOTATION_REQUEST',
  DELETE_ANNOTATION_SUCCESS: 'chat/DELETE_ANNOTATION_SUCCESS',
  DELETE_COMMENT_ERROR: 'chat/DELETE_COMMENT_ERROR',
  DELETE_COMMENT_REQUEST: 'chat/DELETE_COMMENT_REQUEST',
  DELETE_COMMENT_SUCCESS: 'chat/DELETE_COMMENT_SUCCESS',
  EDIT_COMMENT_CANCEL_BY_ID: 'chat/EDIT_COMMENT_CANCEL_BY_ID',
  EDIT_COMMENT_ERROR: 'chat/EDIT_COMMENT_ERROR',
  EDIT_COMMENT_REQUEST: 'chat/EDIT_COMMENT_REQUEST',
  EDIT_COMMENT_SET_BY_ID: 'chat/EDIT_COMMENT_SET_BY_ID',
  EDIT_COMMENT_SUCCESS: 'chat/EDIT_COMMENT_SUCCESS',
  EDIT_MSC_CHANNEL_CONFIG_ERROR: 'chat/EDIT_MSC_CHANNEL_CONFIG_ERROR',
  EDIT_MSC_CHANNEL_CONFIG_REQUEST: 'chat/EDIT_MSC_CHANNEL_CONFIG_REQUEST',
  EDIT_MSC_CHANNEL_CONFIG_SUCCESS: 'chat/EDIT_MSC_CHANNEL_CONFIG_SUCCESS',
  FETCH_SUPPLIERS_MSC_SETTINGS_ERROR: 'chat/FETCH_SUPPLIERS_MSC_SETTINGS_ERROR',
  FETCH_SUPPLIERS_MSC_SETTINGS_REQUEST:
    'chat/FETCH_SUPPLIERS_MSC_SETTINGS_REQUEST',
  FETCH_SUPPLIERS_MSC_SETTINGS_SUCCESS:
    'chat/FETCH_SUPPLIERS_MSC_SETTINGS_SUCCESS',
  REINITIALIZE_TRUSTED_THIRD_PARTY_CHANNEL_ERROR:
    'chat/REINITIALIZE_TRUSTED_THIRD_PARTY_CHANNEL_ERROR',
  REINITIALIZE_TRUSTED_THIRD_PARTY_CHANNEL_REQUEST:
    'chat/REINITIALIZE_TRUSTED_THIRD_PARTY_CHANNEL_REQUEST',
  REINITIALIZE_TRUSTED_THIRD_PARTY_CHANNEL_SUCCESS:
    'chat/REINITIALIZE_TRUSTED_THIRD_PARTY_CHANNEL_SUCCESS',
  THREAD_SET_ACTIVE: 'chat/THREAD_SET_ACTIVE',
  THREAD_SET_INACTIVE: 'chat/THREAD_SET_INACTIVE',
  CHAT_PANEL_INIT: 'chat/CHAT_PANEL_INIT',
};

export const acknowledgeChannelNotifications = {
  request: ({ channelId }) => ({
    type: types.ACKNOWLEDGE_CHANNEL_NOTIFICATIONS_REQUEST,
    payload: { channelId },
  }),
};

export const acknowledgeThreadNotifications = {
  request: ({ annotationId }) => ({
    type: types.ACKNOWLEDGE_THREAD_NOTIFICATIONS_REQUEST,
    payload: { annotationId },
  }),
};

export const annotationInput = {
  recordEditorState: ({ channelId, channelType, editorState }) => ({
    type: types.ANNOTATION_INPUT_RECORD_EDITOR_STATE,
    payload: {
      channelId,
      channelType,
      editorState,
    },
  }),
};

export const annotationTool = {
  setActive: ({ channelId, channelType, tool }) => ({
    type: types.ANNOTATION_TOOL_SET_ACTIVE,
    payload: { channelId, channelType, tool },
  }),
  setInactive: () => ({
    type: types.ANNOTATION_TOOL_SET_INACTIVE,
  }),
};

export const channelsList = {
  error: () => ({
    type: types.CHANNELS_LIST_ERROR,
  }),
  request: () => ({
    type: types.CHANNELS_LIST_REQUEST,
  }),
  success: () => ({
    type: types.CHANNELS_LIST_SUCCESS,
  }),
};

export const chatDrawer = {
  close: () => ({
    type: types.CHAT_DRAWER_CLOSE,
  }),
  open: () => ({
    type: types.CHAT_DRAWER_OPEN,
  }),
};

export const chatDrawerState = {
  set: ({ activeChannelId, activeChannelType, chatDrawerState }) => ({
    type: types.CHAT_DRAWER_STATE_SET,
    payload: {
      activeChannelId,
      activeChannelType,
      chatDrawerState,
    },
  }),
};

export const chatSocketInitialize = {
  request: () => ({
    type: types.CHAT_SOCKET_INITIALIZE_REQUEST,
  }),
};

export const commentInput = {
  recordEditorState: ({ annotationId, editorState }) => ({
    type: types.COMMENT_INPUT_RECORD_EDITOR_STATE,
    payload: {
      annotationId,
      editorState,
    },
  }),
};

export const chatApp = {
  init: ({
    activeChannelType,
    annotationId,
    channelId,
    isExportControlled,
    isOwner,
    partMasterVersion,
    source,
    techDataPackageRootUuid,
  }) => ({
    type: types.CHAT_APP_INIT,
    payload: {
      activeChannelType,
      annotationId,
      channelId,
      isExportControlled,
      isOwner,
      partMasterVersion,
      source,
      techDataPackageRootUuid,
    },
  }),
  reset: () => ({
    type: types.CHAT_APP_RESET,
  }),
};

export const createAnnotation = {
  error: notify(
    ({ channelId, error }) => ({
      type: types.CREATE_ANNOTATION_ERROR,
      payload: { channelId, error },
    }),
    'Failed to send message',
  ),
  inputReinitialized: (channelId) => ({
    type: types.CREATE_ANNOTATION_INPUT_REINITIALIZED,
    payload: { channelId },
  }),
  recordAnnotationCreating: ({ channelId }) => ({
    type: types.CREATE_ANNOTATION_RECORD_ANNOATION_CREATING,
    payload: {
      channelId,
    },
  }),
  request: ({
    channelId,
    channelType,
    comment,
    actionUuid,
    commentedOnQuoteItemId,
    partMasterUuid,
    partMasterVersion,
  }) => ({
    type: types.CREATE_ANNOTATION_REQUEST,
    payload: {
      channelId,
      channelType,
      comment,
      actionUuid,
      commentedOnQuoteItemId,
      partMasterUuid,
      partMasterVersion,
    },
  }),
  success: ({ channelId, channelType }) => ({
    type: types.CREATE_ANNOTATION_SUCCESS,
    payload: {
      channelId,
      channelType,
    },
  }),
};

export const createComment = {
  error: notify(
    (error, annotationId) => ({
      type: types.CREATE_COMMENT_ERROR,
      payload: { error, annotationId },
    }),
    'Failed to save comment',
  ),
  inputReinitialized: (annotationId) => ({
    type: types.CREATE_COMMENT_INPUT_REINITIALIZED,
    payload: { annotationId },
  }),
  request: ({ annotationId, comment }) => ({
    type: types.CREATE_COMMENT_REQUEST,
    payload: { annotationId, comment },
  }),
  success: ({ annotationId }) => ({
    type: types.CREATE_COMMENT_SUCCESS,
    payload: {
      annotationId,
    },
  }),
};

export const deleteAnnotation = {
  error: notify(
    (error) => ({
      type: types.DELETE_ANNOTATION_ERROR,
      payload: { error },
    }),
    'Failed to delete comment',
  ),
  request: ({ annotationId }) => ({
    type: types.DELETE_ANNOTATION_REQUEST,
    payload: { annotationId },
  }),
  success: () => ({
    type: types.DELETE_ANNOTATION_SUCCESS,
  }),
};

export const deleteComment = {
  error: notify(
    (error) => ({
      type: types.DELETE_COMMENT_ERROR,
      payload: { error },
    }),
    'Failed to delete comment',
  ),
  request: ({ commentId }) => ({
    type: types.DELETE_COMMENT_REQUEST,
    payload: { commentId },
  }),
  success: () => ({
    type: types.DELETE_COMMENT_SUCCESS,
  }),
};

export const editComment = {
  cancel: ({ commentId }) => ({
    type: types.EDIT_COMMENT_CANCEL_BY_ID,
    payload: { commentId },
  }),
  error: notify(
    (error, commentId) => ({
      type: types.EDIT_COMMENT_ERROR,
      payload: { error, commentId },
    }),
    'Failed to save comment',
  ),
  request: ({ commentId, content }) => ({
    type: types.EDIT_COMMENT_REQUEST,
    payload: { commentId, content },
  }),
  set: ({ commentId }) => ({
    type: types.EDIT_COMMENT_SET_BY_ID,
    payload: { commentId },
  }),
  success: ({ commentId }) => ({
    type: types.EDIT_COMMENT_SUCCESS,
    payload: { commentId },
  }),
};

export const editMscChannelConfig = {
  error: notify(
    (error) => ({
      type: types.EDIT_MSC_CHANNEL_CONFIG_ERROR,
      payload: { error },
    }),
    'Failed to update specialist',
  ),
  request: ({ mscChannelId, mscSpecialistId }) => ({
    type: types.EDIT_MSC_CHANNEL_CONFIG_REQUEST,
    payload: { mscChannelId, mscSpecialistId },
  }),
  success: () => ({
    type: types.EDIT_MSC_CHANNEL_CONFIG_SUCCESS,
  }),
};

export const fetchSuppliersMscSettings = {
  error: () => ({
    type: types.FETCH_SUPPLIERS_MSC_SETTINGS_ERROR,
  }),
  request: () => ({
    type: types.FETCH_SUPPLIERS_MSC_SETTINGS_REQUEST,
  }),
  success: ({ suppliersMscSettings }) => ({
    type: types.FETCH_SUPPLIERS_MSC_SETTINGS_SUCCESS,
    payload: { suppliersMscSettings },
  }),
};

export const reinitializeTrustedThirdPartyChannel = {
  error: notify(
    (error) => ({
      type: types.REINITIALIZE_TRUSTED_THIRD_PARTY_CHANNEL_ERROR,
      payload: { error },
    }),
    'Failed to reinitialize the chat',
  ),
  request: () => ({
    type: types.REINITIALIZE_TRUSTED_THIRD_PARTY_CHANNEL_REQUEST,
  }),
  success: () => ({
    type: types.REINITIALIZE_TRUSTED_THIRD_PARTY_CHANNEL_SUCCESS,
  }),
};

export const threads = {
  setActive: ({ annotationId, channelId }) => ({
    type: types.THREAD_SET_ACTIVE,
    payload: { annotationId, channelId },
  }),
  setInactive: ({ channelId }) => ({
    type: types.THREAD_SET_INACTIVE,
    payload: { channelId },
  }),
};

export const chatPanel = {
  init: ({
    isExportControlled,
    isOwner,
    partMasterVersion,
    source,
    techDataPackageRootUuid,
  }) => ({
    type: types.CHAT_PANEL_INIT,
    payload: {
      isExportControlled,
      isOwner,
      partMasterVersion,
      source,
      techDataPackageRootUuid,
    },
  }),
};
